import { Button } from "@/app/(components)/Basic/Button";
import { Modal } from "@/app/(components)/Basic/Modal";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
}

const ChooseArtOrderSuccessModal = ({ isVisible, onClose }: Props) => {
  return (
    <Modal
      isOpen={isVisible}
      onClose={() => onClose()}
      title="Success"
      smallPadding
      centeredTitle
      className="!pl-14"
    >
      <div className="text-center">
        <div className="text-body-2 mb-8">Invitation sent successfully.</div>

        <Button onClick={() => onClose()}>OK</Button>
      </div>
    </Modal>
  );
};

export default ChooseArtOrderSuccessModal;
